<template lang="pug">
header.c-page-header.c-page-header--large
  .row
    .column
      h1.c-page-header__headline
        span.show-for-medium Faites votre <b>check-up Seraphin</b> et découvrez enfin l’assurance dont vous avez <b>vraiment</b> besoin
        span.hide-for-medium Check-up Seraphin
      ul.c-progress
        li.c-progress__step(:class="{'is-active': isCurrent('profiles')}" @click="goTo('Profiles')")
          span.c-progress__label Votre profil
        li.c-progress__step(:class="{'is-active': isCurrent('insurances')}" @click="goTo('Insurances')")
          span.c-progress__label Vos assurances
        li.c-progress__step(:class="{'is-active': isCurrent('results')}")
          span.c-progress__label Résultats
</template>

<script>
export default {
  props: {
    current: {
      default: ''
    }
  },
  methods: {
    isCurrent (step) {
      return this.current === step
    },
    goTo (route) {
      this.$router.push({ name: route })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Header.vue